import { createSlice } from '@reduxjs/toolkit';

export const paginationSlice = createSlice({
  name: 'pagination',
  initialState: {
    rowsPerPage: 10, // Default value
    pagenumber: 0,
    sortModel: [],
    filterModel: { items: [] }
  },
  reducers: {
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pagenumber = action.payload;
    },
    setSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    clearSortModel: (state) => {
      state.sortModel = [];
    },
    setFilterModel: (state, action) => {
      state.filterModel = action.payload;
    },
    resetFilterModel: (state) => {
      state.filterModel = { items: [] };
    }
  }
});

export const { setRowsPerPage, setPageNumber, setSortModel, setFilterModel, resetFilterModel, clearSortModel } =
  paginationSlice.actions;
export default paginationSlice.reducer;
